import {
    type DataFrame,
    isNonBlankString,
    type ReceiptFrame,
    type ReceiptState,
} from 'src/services/websocket/ws-protocol';

export type ReceiptDrainDecision = Readonly<{
    state: ReceiptState;
    frame: ReceiptFrame | null;
}>;

export function createReceiptState(): ReceiptState {
    return { pending: [] };
}

/**
 * Deduplication is scoped to the pending batch, which the flush cadence keeps
 * small and bounded. Cross-batch duplicates (a reconnect replaying an already
 * receipted event) are deliberately re-receipted: the server deduplicates by
 * event ID, and batch-scoped state keeps memory flat for the hook's lifetime.
 */
export function collectReceipt(state: ReceiptState, frame: DataFrame): ReceiptState {
    const eventId = frame.event_id;
    if (!isNonBlankString(eventId) || state.pending.includes(eventId)) {
        return state;
    }

    return { pending: [...state.pending, eventId] };
}

export function drainReceiptBatch(state: ReceiptState): ReceiptDrainDecision {
    if (state.pending.length === 0) {
        return { state, frame: null };
    }

    return {
        state: { pending: [] },
        frame: { action: 'receipt', event_ids: [...state.pending] },
    };
}
